'use strict';

require('./cn-questionnaire-choices.scss');

module.exports = {
  template: require('./cn-questionnaire-choices.html'),
  controller: require('./cn-questionnaire-choices.controller'),
  controllerAs: 'vm',

  require: {
    ngModel: 'ngModel'
  },

  bindings: {
    choices: '<',
    locked: '<',
    error: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-questionnaire-choices/index.js
 ** module id = 115
 ** module chunks = 0
 **/